import { formatDate } from "../../../../_helpers";
import { getGridContextMenuList } from "../../../../_helpers/getGridContextMenuList";
import { LOCAL_STORAGE_GRID_KEYS } from "../../../../_constants";
import { LabelColumnV2, LinkColumnV2 } from "../../../../components/DataGridV2/DataColumnsV2";
import { Link } from "react-router-dom";

export const getQuestionnaireTemplateColumns = ({ t,
    theme,
    keyPrefix,
    i18n,
    apiRef,
    onSelect,
}) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_TEMPLATE_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        getValueForCopy: (rowData, extraData) => {
            let text = ""
            switch (extraData.fieldName) {
                case "createdOn":
                    text = formatDate(new Date(rowData?.createdOn), true, "-", false)
                    break;
                case "modifiedOn":
                    text = formatDate(new Date(rowData?.modifiedOn), true, "-", false)
                    break;
                case "active":
                    text = rowData[extraData.fieldName] ? t("general.yes") : t("general.no")
                    break;
                default:
                    text = rowData[extraData.fieldName]
                    break;
            }
            return text
        },
        getValueForFilter: (rowData, extraData) => {
            let value = ""
            switch (extraData.fieldName) {
                case "version":
                    value = rowData[extraData.fieldName]?.toString()
                    break;
                default:
                    value = rowData[extraData.fieldName]
                    break;
            }
            return value
        },
        mode: "client"
    })
    return [
        {
            field: "name",
            headerName: t("general.template.name"),
            flex: 1,
            minWidth: 90,
            download: true,
            getApplyQuickFilterFn: (searchVal) => {
                return (value, row) => {
                    return value?.toLowerCase().includes(searchVal.toLowerCase()) || row?.searchField?.toLowerCase().includes(searchVal.toLowerCase());
                };
            },
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LinkColumnV2
                        component={onSelect ? "div" : Link}
                        to={"/vragenlijst-sjabloon/" + params.row.id}
                        label={rowData.name}
                        cellSubMenuOptions={{
                            options: getOptions({ field: "name", isQuickFilterDisplay: Boolean(rowData.name) }),
                            extraData: { fieldName: "name" }
                        }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "description",
            headerName: t('general.description'),
            flex: 1,
            minWidth: 110,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;

                return <LabelColumnV2
                    label={rowData.description}
                    cellSubMenuOptions={{ options: getOptions({ field: "description", isQuickFilterDisplay: Boolean(rowData.description) }), extraData: { fieldName: "description" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "version",
            headerName: t('general.version'),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData.version}
                    cellSubMenuOptions={{ options: getOptions({ field: "version", isQuickFilterDisplay: Boolean(rowData.version) }), extraData: { fieldName: "version" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "createdOn",
            headerName: t('general.createdOn'),
            flex: 1,
            minWidth: 90,
            type: "dateTime",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData?.createdOn ? formatDate(new Date(rowData?.createdOn), true, "-", false) : ""}
                    cellSubMenuOptions={{ options: getOptions({ field: "createdOn", isQuickFilterDisplay: rowData?.createdOn }), extraData: { fieldName: "createdOn", type: "dateTime" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "createdBy",
            headerName: t('general.createdBy'),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData?.createdBy}
                    cellSubMenuOptions={{ options: getOptions({ field: "createdBy", isQuickFilterDisplay: rowData?.createdBy }), extraData: { fieldName: "createdBy" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "modifiedOn",
            headerName: t('general.modifiedOn'),
            flex: 1,
            minWidth: 90,
            type: "dateTime",
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData?.modifiedOn ? formatDate(new Date(rowData?.modifiedOn), true, "-", false) : ""}
                    cellSubMenuOptions={{ options: getOptions({ field: "modifiedOn", isQuickFilterDisplay: rowData?.modifiedOn }), extraData: { fieldName: "modifiedOn", type: "dateTime" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "modifiedBy",
            headerName: t('general.modifiedBy'),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData?.modifiedBy}
                    cellSubMenuOptions={{ options: getOptions({ field: "modifiedBy", isQuickFilterDisplay: rowData?.modifiedBy }), extraData: { fieldName: "modifiedBy" } }}
                    request={rowData}
                />
            },
        },
        {
            field: "active",
            headerName: t('general.active'),
            flex: 1,
            minWidth: 90,
            download: true,
            type: "boolean",
            renderCell: (params) => {
                const rowData = params.row;
                const isActive = rowData.active === true;
                return (
                    <LabelColumnV2
                        color={isActive ? theme.palette.success.main : theme.palette.error.main}
                        label={isActive ? t("general.yes") : t("general.no")}
                        cellSubMenuOptions={{ options: getOptions({ field: "active", isQuickFilterDisplay: typeof rowData.active === "boolean" }), extraData: { fieldName: "active", type: "boolean" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "noOfSurveys",
            headerName: t('questionnaire.template.activeQuestionnaires'),
            flex: 1,
            minWidth: 110,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return <LabelColumnV2
                    label={rowData.noOfSurveys}
                    cellSubMenuOptions={{ options: getOptions({ field: "noOfSurveys", isQuickFilterDisplay: Boolean(rowData.noOfSurveys) }), extraData: { fieldName: "noOfSurveys" } }}
                    request={rowData}
                />
            },
        },

    ];
}

export const getTemplateGridNavigationItem = (t) => {
    const to = "/vragenlijst-sjabloon"
    return {
        breadCrumbs: [{ breadCrumbTitle: t('general.template'), title: t('general.template'), to }],
        tabs: [{ title: t('general.list'), to }]
    }
}
